import React, { useState } from 'react';
import { processFile } from '../../api/AgentApi';

interface FileUploadComponentProps {
  agentUuid: string;
}

const FileUploadComponent: React.FC<FileUploadComponentProps> = ({
  agentUuid,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [message, setMessage] = useState('');
  const [progress, setProgress] = useState(0);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleFileUpload = async () => {
    if (!file) {
      setMessage('Please select a file first.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      setProgress(0);
      const result = await processFile(agentUuid, formData, setProgress);
      setMessage(result);
    } catch (error: unknown) {
      const message =
        error instanceof Error ? error.message : 'Unknown error occurred';
      setMessage(message);
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleFileUpload}>Upload File</button>
      {progress > 0 && progress < 100 && (
        <div>
          <p>Uploading... {progress}%</p>
          <progress value={progress} max={100} />
        </div>
      )}
      {progress === 100 && <p>Upload Complete!</p>}
      {message && <p>{message}</p>}
    </div>
  );
};

export default FileUploadComponent;
